export const LIVE_STREAM_URL =
  process.env.LIVE_STREAN_URL ||
  "https://broadcast.radiosavta.com:8000/radio.mp3";